import { render, html } from "lit-html";
import { translate } from "@escapio/shared/l10n/translate";

export default class extends HTMLElement {
	render(cancelation) {
		const template = html`<label class="form-checkbox">
			<input
				class="form-checkbox__input"
				type="checkbox"
				@change=${this.onChange}
				value="cancelation"
				.checked=${cancelation}
			/>
			<span class="form-checkbox__label">
				<i class="cancelation-filter__icon fa fa-money"></i>
				${translate("basic_free_cancelation")}
			</span>
		</label>`;
		render(template, this, { host: this });
	}
}
